import React from "react";

/**
 * CrosswordContextType represents the type of the crossword puzzle itself, as
 * well as provides callbacks for the core implementation of crossword
 * user-interaction logic. This ensures that any number of individual components
 * can leverage a single core implementation.
 */

function nop() {
	// Do Nothing
}

/**
 * CrosswordContext represents the crossword puzzle itself, as well as provides
 * callbacks for the core implementation of crossword user-interaction logic.
 * This ensures that any number of individual components can leverage a single
 * core implementation.
 */
export const CrosswordContext = React.createContext({
	size: 0,
	gridData: [],
	// clues: { across: [], down: [] },

	handleInputKeyDown: nop,
	handleInputChange: nop,
	handleCellClick: nop,
	handleInputClick: nop,
	handleClueSelected: nop,
	registerFocusHandler: nop,

	focused: false,
	selectedPosition: { row: 0, col: 0 },
	selectedDirection: "across",
	selectedNumber: "",

	crosswordCorrect: false,
});

export const CrosswordSizeContext = React.createContext({
	cellSize: 0,
	cellPadding: 0,
	cellInner: 0,
	cellHalf: 0,
	fontSize: 0,
});
